(function($) {

	const $mobileMasthead = $('#mobile-masthead');
	const $menu = $('.menu-main', $mobileMasthead);
	const mobileMenuEl = document.getElementById('mobile-menu');

	$('#mobile-masthead .hamburger').on('click', function(event) {
		$(this).toggleClass('is-active');
		$('#mobile-masthead').toggleClass('menu-on');
		$(document.body).toggleClass('no-scroll');
	});


	$('.menu-item-has-children .subnavbar-toggler', $menu).on('click', function(event){

		const $a = $(this);
		const $li = $a.parent();
		const $parents = $li.parents('.menu-item-has-children');

		if($a.attr('aria-expanded') === "true" ){
			$a.attr('aria-expanded', 'false');
			$li.removeClass('shown');
			$parents.removeClass('sub-shown');

			if($parents.length < 1){
				$mobileMasthead.removeClass('submenu-opened');
			}

			event.preventDefault();

		}else{
			mobileMenuEl.scrollTop = 0;
			$a.attr('aria-expanded', 'true');
			$li.addClass('shown');
			$parents.addClass('sub-shown');
			$mobileMasthead.addClass('submenu-opened');
		}

		event.preventDefault();

	});

})(jQuery);